import React from "react";
import DownArrow from "../other-icons/DownArrow";

import "./section-breadcrum.m.css";

export const modifySectionNames = [
  {
    sectionSlug: "dh-changemakers",
    sectionName: "DH Changemakers"
  }
];

const BredcrumHtml = ({ item, type }) => {
  let url = "";
  if (type !== "section-page") Number(item[item.length - 1]) && item.pop();

  const removeExtraString = (secname) => {
    let str = "";
    if (secname.includes("-")) {
      const sections = secname.split("-");
      sections.forEach((item) => (str += item + " "));
      str = str.charAt(0) + str.substring(1);
    } else {
      str = secname.charAt(0) + secname.substring(1);
    }
    return str;
  };

  return (
    <>
      {item.map((secname, i) => {
        let sectionName;
        const ifModifySectionExists = modifySectionNames.find((item) => item.sectionSlug === secname);
        if (ifModifySectionExists) {
          sectionName = ifModifySectionExists.sectionName;
        } else {
          sectionName = removeExtraString(decodeURI(secname));
        }

        if (item.length !== i) {
          url += `/${secname}`;
        }

        return (
          <React.Fragment key={i}>
            {isNaN(sectionName) ? (
              <a key={i} href={url}>
                <span className="arrow">
                  <DownArrow color="black" height="8px" width="8px" />
                </span>
                <span styleName="item">{sectionName}</span>
              </a>
            ) : null}
          </React.Fragment>
        );
      })}
    </>
  );
};

const SectionBreadcrum = ({ initialPath, type = "section-page" }) => {
  let path = "";

  if (initialPath.includes("#")) {
    const lastIndex = initialPath.indexOf("#");
    path = initialPath.slice(1, lastIndex);
  } else {
    path = initialPath.slice(1, initialPath.length);
  }

  const section = path.split("/");

  return (
    <div styleName="wrapper">
      <a href="/">
        <span styleName="item">Home</span>
      </a>
      <BredcrumHtml item={section} type={type} />
    </div>
  );
};

export default SectionBreadcrum;
